export interface BrandListState {
  /** A brand is selected (it may still have no usable tenant id). */
  hasBrand: boolean;
  /** The brand list has answered. */
  loaded: boolean;
  /** The brand list could not be read. */
  failed: boolean;
  /** How many brands the list holds. */
  count: number;
}

/** Whether the active brand has settled: one is selected, or none will be (the list answered with none, or could not be
 *  read). A page or card waiting on a brand shows its loading state only while this is false. Pure. */
export const brandSettledOf = ({ hasBrand, loaded, failed, count }: BrandListState): boolean =>
  hasBrand || failed || (loaded && count === 0);

/** Whether a brand's list has still to answer for the brand on screen: while no tenant is known and one may still
 *  arrive, or until a read for this tenant has settled (success or failure). A list shows its empty state only once
 *  this is false, so "nothing yet" never reads as "none". Pure. */
export const listPendingOf = (
  tenantId: number | undefined,
  loadedFor: number | undefined,
  brandSettled: boolean,
): boolean => (tenantId ? loadedFor !== tenantId : !brandSettled);
